const FEED_NAME = new Map([
    ['newsapi:bloomberg', 'Bloomberg'],
    ['newsapi:business-insider', 'Business Insider'],
    ['newsapi:business-insider-uk', 'Business Insider (UK)'],
    ['newsapi:the-economist', 'The Economist'],
    ['newsapi:the-wall-street-journal', 'The Wall Street Journal'],
    ['ent', 'Entertainment Weekly'],
    ['newsapi:associated-press', 'Associated Press'],
    ['newsapi:cnbc', 'CNBC'],
    ['news', 'CNN'],
    ['newsapi:google-news', 'Google News'],
    ['newsapi:reuters', 'Reuters'],
    ['newsapi:the-huffington-post', 'The Huffington Post'],
    ['newsapi:the-new-york-times', 'The New York Times'],
    ['newsapi:the-washington-post', 'The Washington Post'],
    ['newsapi:time', 'Time'],
    ['newsapi:usa-today', 'USA Today'],
    ['newsapi:bbc-sport', 'BBC Sport'],
    ['sports', 'ESPN'],
    ['newsapi:fox-sports', 'Fox Sports'],
    ['newsapi:ars-technica', 'Ars Technica'],
    ['newsapi-country:au', 'Australia'],
    ['newsapi-country:ca', 'Canada'],
    ['newsapi-country:cn', 'China'],
    ['newsapi-country:fr', 'France'],
    ['newsapi-country:de', 'Germany'],
    ['newsapi-country:in', 'India'],
    ['newsapi-country:it', 'Italy'],
    ['newsapi-country:jp', 'Japan'],
    ['newsapi-country:mx', 'Mexico'],
    ['newsapi-country:my', 'Malaysia'],
    ['newsapi-country:nd', 'Netherlands'],
    ['newsapi-country:sg', 'Singapore'],
    ['newsapi-country:kr', 'South Korea'],
    ['newsapi-country:th', 'Thailand'],
    ['custom', ''],
    ['data-list', ''],
]);

export function feedDisplayName(feed: string): string {
    return FEED_NAME.get(feed) ?? feed.replace(/^newsapi(-[a-z]+)?:\s*/, '').toUpperCase();
}
